import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
    this.#restoreSavedLayout();
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }


  static #validLayouts = {
    mobile: ['mobile-single', 'default'],
    desktop: ['default', 'zoom-out'],
  };

  #restoreSavedLayout() {
    const { grid } = this.refs;
    if (!grid) return;

    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
    const stored = sessionStorage.getItem(`product-grid-view-${viewport}`);
    const valid = ResultsList.#validLayouts[viewport];
    const value =
      stored && valid.includes(stored) ? stored : 'default';

    this.#setLayout(value);

    const radioName = viewport === 'desktop' ? 'grid' : 'grid-mobile';
    const option = this.querySelector(
      `input[type="radio"][name="${radioName}"][value="${value}"]`
    );
    if (option instanceof HTMLInputElement) {
      option.checked = true;
    }
  }

  #handleMediaQueryChange = () => {
    this.#restoreSavedLayout();
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
